//#region import libraries

//react
import React from 'react';
import { NavLink } from 'react-router-dom';

//bootstrap
import { Row, Col, Image, Badge, Navbar, Nav, Container } from 'react-bootstrap';

//media query
import { useMediaQuery } from 'react-responsive'

//images
import phonelogo from "_assets/images/PRM-Logo-PNG/logo.png";
//#endregion

const NavBar = () => {

  //#region media query and styles
  const isPhone = useMediaQuery({ query: '(max-width: 1224px)' })

  const navText = {
    fontSize: 30,
    fontWeight: 100,
    marginRight: 30,
    paddingTop: 5,
    color: 'black',
    textDecoration: 'none'
  };

  const mobileNavText = {
    fontSize: 15,
    fontWeight: 100,
    color: 'black',
    textDecoration: 'none',
    marginRight: 8,
  };

  const underline = {
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderColor: '#307FE2',
    fontWeight: '200'
  };
  //#endregion

  //#region render
  if (!isPhone) {
    return (
      <Navbar bg="white" expand="lg" className='px-5'>

        {/* Logo */}
        <Container href="/">
          <Image
            src={phonelogo}
            height={'auto'}
            width={'140px'}
          />
        </Container>

        {/* Nav Links */}
        <Navbar.Collapse>
          <Nav>
            <NavLink to="/" style={navText} exact activeStyle={underline}>Home</NavLink>
            <NavLink to="/business" style={navText} exact activeStyle={underline}>Business</NavLink>
            <NavLink to="/about-us" style={navText} exact activeStyle={underline}>About</NavLink>
            <NavLink to="/contact" style={navText} exact activeStyle={underline}>Contact</NavLink>
          </Nav>
        </Navbar.Collapse>

        <NavLink to="/login"><Badge pill bg="primary" style={{ width: 100, padding: 10 }}>PRM Portal</Badge></NavLink>
      </Navbar>
    );
  }
  else {
    return (
        <Navbar bg="white" className='p-2'>
            {/* Logo */}
            <div>
              <img
                src={phonelogo}
                width={60}
              />
            </div>

            {/* Mobile Nav Links */}
            <div style={{ marginTop: 10, marginLeft: 5, }}>

              <NavLink to="/" style={mobileNavText} exact activeStyle={underline}>Home</NavLink>
              <NavLink to="/business" style={mobileNavText} exact activeStyle={underline}>Business</NavLink>
              <NavLink to="/about-us" style={mobileNavText} exact activeStyle={underline}>About</NavLink>
              <NavLink to="/contact" style={mobileNavText} exact activeStyle={underline}>Contact</NavLink>
            </div>

            {/* Login Button */}
            <div style={{ padding: 8 }}>
              <NavLink to="/login"><Badge pill bg="primary" style={{}}>PRM Portal</Badge></NavLink>
            </div>
        </Navbar>
    );
  }
  //#endregion
};

export default NavBar;
